import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from './components/HeroCarousel';
import CategoryGrid from './components/CategoryGrid';
import LatestGrid from './components/LatestGrid';
import HotList from './components/HotList';
import SiteIntro from './components/SiteIntro';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta(
    '国语对白做受69高清影音资源集锦',
    '国语对白做受69网站汇集丰富的影视影音资源，涵盖国语对白相关内容，方便用户查询和了解多样影音作品。',
    '国语对白做受69,国语对白,影音资源,视频内容,影视作品,国语视频,影音合集'
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <Navbar />
      <main className="flex-1">
        <HeroCarousel />
        <div className="mx-auto flex w-full max-w-[1360px] flex-col gap-14 py-12 md:py-16">
          <CategoryGrid />
          <LatestGrid />
          <HotList />
          <SiteIntro />
        </div>
      </main>
      <Footer />
    </div>
  );
}